import React from 'react';
import {
  MasonryEngine,
  type MasonryEngineNodeQueryParams,
} from '@leagueplatform/masonry-engine';
import { createAsyncNode } from '@leagueplatform/masonry-api';
import { driver } from '../masonry-engine/masonry-driver/driver';
import { useStableQueryParams } from '../utils/use-stable-query-params';

type MasonryProps = {
  rootNodeId: string;
  initialQueryParams?: MasonryEngineNodeQueryParams;
};

export const Masonry = ({ rootNodeId, initialQueryParams }: MasonryProps) => {
  const stableParams = useStableQueryParams(initialQueryParams);
  const rootNode = React.useMemo(
    () =>
      createAsyncNode({
        id: rootNodeId,
        initialQueryParams: stableParams,
      }),
    [rootNodeId, stableParams],
  );

  return <MasonryEngine driver={driver} rootNode={rootNode} />;
};
